import React, { useEffect } from 'react';
import { Button, Container, Grow, Card, Chip, CardMedia, Typography, CircularProgress, Grid} from '@material-ui/core/';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useParams, Link } from 'react-router-dom';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ThumbUpAltOutlined from '@material-ui/icons/ThumbUpAltOutlined';
import GoToTop from '../Functional/GoToTop';

import { getProject, likeProject } from '../../actions/projects';
import useStyles from './styles';
import { store } from '../../index';
// import useCommonStyles from './../CommonStyle/commonStyle';
// import { deletePost, likePost } from '../../actions/posts'


type RootState = ReturnType<typeof store.getState>;

const Project = () => {
  const { project, isLoading } = useSelector((state: RootState) => state.projects);
  const dispatch = useDispatch();
  // const history = useHistory();
  const classes = useStyles();
  // const commonClasses = useCommonStyles();
  const { id } = useParams<{ id: any }>();
  const user = JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}');

  console.log(project)
  useEffect(() => {
    dispatch(getProject(id));
  }, [id]);

  // useEffect(() => {
  //   if (project) {
  //     dispatch(getProjectsBySearch({ search: "", tags: project?.tags.join(',') }, 1));
  //   }
  // }, [project]);

  if (!project) return null;

  const Likes = () => {
    if (project.likeCount !== undefined && project.likeCount.length > 0) {
      return project.likeCount.find((like: string) => like === (user?.result?.googleId || user?.result?._id))
        ? (
          <><ThumbUpAltIcon fontSize="small" />&nbsp;{project.likeCount.length > 2 ? `You and ${project.likeCount.length - 1} others` : `${project.likeCount.length} like${project.likeCount.length > 1 ? 's' : ''}`}</>
        ) : (
          <><ThumbUpAltOutlined fontSize="small" />&nbsp;{project.likeCount.length} {project.likeCount.length === 1 ? 'Like' : 'Likes'}</>
        );
    } else {
      console.log("posts was empty");
    }

    return <><ThumbUpAltOutlined fontSize="small" />&nbsp;Like</>;
  };

  // const openProject = (_id: any) => history.push(`/projects/${_id}`);

  if (isLoading) {
    return (
      // <Paper elevation={6} className={classes.loadingPaper}>
      //   <CircularProgress size="7em" />
      // </Paper>
      <Grow in>
        <Container maxWidth="lg">
          <Grid container justifyContent="center" >
            <CircularProgress size="5em" />
          </Grid>
          {/* <Card className={classes.card}>
          <CircularProgress size="7em" />
        </Card> */}
        </Container>
      </Grow>

    );
  }

  // const recommendedProjects = projects.filter(({ _id }) => _id !== project._id);

  return (
    <Grow in>
      <Container maxWidth="lg">
        <Card className={classes.card}>
          <Container className={classes.projectNameDiv}>
            <Typography>
              {project.name}
            </Typography>
          </Container>
          <CardMedia className={classes.media} image={project.imageUrl || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'} title={project.title} />
          <div className={classes.content}>
            <Typography variant="h3" component={"span"} className={classes.title}>&nbsp;{project.title}&nbsp;&nbsp;<br /></Typography>
            <Button size="small" color="primary" disabled={!user?.result} onClick={() => dispatch(likeProject(project._id))}>
              <Likes />
            </Button>
            <Typography gutterBottom variant="h6" color="textSecondary" component="h2">{project.tags.map((tag, index) => <Chip key={index} label={'# ' + tag} className={classes.chip} />)}</Typography>
            <Typography variant="body1">{moment(project.createdAt).format('L')}</Typography>


            <Typography variant="h5" component={"span"} className={classes.subtitle}>
              <Typography component={"span"} className={classes.subtitleShadow}>PURPOSE</Typography>
              目的
            </Typography>
            <Typography gutterBottom variant="body1" component="p" className={classes.body}>{project.purpose}</Typography>
            <Typography variant="h5" component={"span"} className={classes.subtitle}>
              <Typography component={"span"} className={classes.subtitleShadow}>GOLE</Typography>
              目標
            </Typography>
            <Typography gutterBottom variant="body1" component="p" className={classes.body}>{project.goal}</Typography>
            <Typography variant="h5" component={"span"} className={classes.subtitle}>
              <Typography component={"span"} className={classes.subtitleShadow + ' ' + classes.lightGreen}>RECOURCES</Typography>
              求めているリソース
            </Typography>
            <Typography gutterBottom variant="body1" component="p" className={classes.body}>{project.resources}</Typography>
            <Typography variant="h5" component={"span"} className={classes.subtitle}>
              <Typography component={"span"} className={classes.subtitleShadow}>DISCRIPTION</Typography>
              概要
            </Typography>
            <Typography gutterBottom variant="body1" component="p" className={classes.body}>{project.message}</Typography>
            <Typography variant="h5" component={"span"} className={classes.subtitle}>
              <Typography component={"span"} className={classes.subtitleShadow}>PROJECR STATUS</Typography>
              プロジェクトの現状
            </Typography>
            <Typography gutterBottom variant="body1" component="p" className={classes.body}>{project.status}</Typography>
            <Button component={Link} to="/projects/co-creation-form" className={classes.buttonRequest} variant="contained" color="inherit" >共創申請</Button>

            {/* <Typography variant="body1">{moment(project.createdAt).fromNow()}</Typography> */}
          </div>
          {/* <Divider style={{ margin: '20px 0' }} />
          <Typography variant="body1"><strong>Realtime Chat - coming soon!</strong></Typography>
          <Divider style={{ margin: '20px 0' }} />
          <Typography variant="body1"><strong>Comments - coming soon!</strong></Typography>
          <Divider style={{ margin: '20px 0' }} /> */}

        </Card>
        <GoToTop/>
      </Container>
    </Grow>

  );

};

export default Project;